import { j as e } from "./index.es33.js";
import { memo as d } from "react";
import "./index.es133.js";
import "react-dom";
import "./index.es134.js";
import { TimeZoneDate as j } from "./index.es506.js";
import { isCurrentMonth as T, isCurrentDay as n } from "./index.es636.js";
import { Day as S } from "./index.es637.js";
import { Weeks as M } from "./index.es638.js";
import { getMonthList as b } from "./index.es639.js";
import c from "./index.es640.js";
var Z = /*#__PURE__*/d(function (_ref) {
  var _o$start, _o$end;

  var o = _ref.selectedRange,
      s = _ref.selectedDate,
      l = _ref.date,
      p = _ref.isDateDisabled,
      m = _ref.onDateHover,
      h = _ref.onSelectDate;

  var f = b(l),
      u = new j(),
      i = ((o === null || o === void 0 ? void 0 : (_o$start = o.start) === null || _o$start === void 0 ? void 0 : _o$start.getTime()) || 0) < ((o === null || o === void 0 ? void 0 : (_o$end = o.end) === null || _o$end === void 0 ? void 0 : _o$end.getTime()) || 0) ? o : {
    start: o === null || o === void 0 ? void 0 : o.end,
    end: o === null || o === void 0 ? void 0 : o.start
  },
      a = function a(t) {
    var _i$start, _i$end;

    return !!(i !== null && i !== void 0 && i.start && i !== null && i !== void 0 && i.end && t.getTime() > ((i === null || i === void 0 ? void 0 : (_i$start = i.start) === null || _i$start === void 0 ? void 0 : _i$start.getTime()) || 0) && t.getTime() < ((i === null || i === void 0 ? void 0 : (_i$end = i.end) === null || _i$end === void 0 ? void 0 : _i$end.getTime()) || 0));
  },
      g = function g(t) {
    return s ? n(s, t) : i !== null && i !== void 0 && i.start ? n(i === null || i === void 0 ? void 0 : i.start, t) : i !== null && i !== void 0 && i.end ? n(i === null || i === void 0 ? void 0 : i.end, t) : !1;
  },
      x = function x(t) {
    return !!(s ? n(s, t) : (i === null || i === void 0 ? void 0 : i.end) && n(i === null || i === void 0 ? void 0 : i.end, t));
  };

  return e.jsx("div", {
    children: e.jsxs("table", {
      className: c.tableInner,
      children: [e.jsx(M, {}), e.jsx("tbody", {
        children: f.map(function (t) {
          return e.jsx("tr", {
            children: t.week.map(function (r) {
              return e.jsx("td", {
                className: c.calendarDayContainer,
                children: T(r, l) && e.jsx(S, {
                  onClick: function onClick() {
                    return h === null || h === void 0 ? void 0 : h(r);
                  },
                  onMouseEnter: function onMouseEnter() {
                    return m === null || m === void 0 ? void 0 : m(r);
                  },
                  onMouseLeave: function onMouseLeave() {
                    return m === null || m === void 0 ? void 0 : m(null);
                  },
                  onFocus: function onFocus() {
                    return m === null || m === void 0 ? void 0 : m(r);
                  },
                  isDisabled: p === null || p === void 0 ? void 0 : p(r),
                  isHighlighted: a(r),
                  isStartSelected: g(r),
                  isEndSelected: x(r),
                  isToday: n(u, r),
                  children: r.getDate()
                })
              }, r.toString());
            })
          }, t.key);
        })
      })]
    })
  });
});
export { Z as Month };